import { TalentComment } from "../../talents/talentAPI";
import { TalentStatus } from "../../talents/types/common";
import {
  RemoveTalentComment,
  UpdateTalentComment,
} from "../../talents/types/commands";

export const mapCommentToUpdateCommand = (
  comment: TalentComment,
  talentId: string | undefined,
  commentText: string,
): UpdateTalentComment => {
  if (!talentId) {
    throw new Error("TalentId is required");
  }
  return {
    id: comment.id,
    version: comment.version,
    talentId: talentId,
    comment: commentText,
    authorId: comment.authorId,
    authorFirstName: comment.authorFirstName,
    authorLastName: comment.authorLastName,
  };
};

export const mapCommentToRemoveCommand = (
  comment: TalentComment,
): RemoveTalentComment => {
  return {
    id: comment.id,
    version: comment.version,
  };
};

export const getRelatedStatusDisplayPrefix = (
  relatedStatus: TalentStatus | null | undefined,
  t: (key: string) => string,
): string | undefined => {
  if (!relatedStatus) {
    return undefined;
  }
  return t(`talentProfile:${relatedStatus}`);
};

export const canDeleteTalentComment = (
  relatedStatus: TalentStatus | null | undefined,
): boolean => relatedStatus == null;

export interface EditCommentInput {
  id: string | null;
  commentText: string;
}
